// @ts-nocheck
import { createSelector } from '@reduxjs/toolkit';

const editItemSelector = (state) => state.editItem;

export const getActiveView = createSelector(
  editItemSelector,
  (editItem) => editItem.activeView
);

export const getStages = createSelector(
  editItemSelector,
  (editItem) => editItem.stages
);

export const getFormData = createSelector(
  editItemSelector,
  (editItem) => editItem.formData
);

export const getHasVariants = createSelector(
  editItemSelector,
  (editItem) => editItem.hasVariants
);

export const getSubtotals = createSelector(
  editItemSelector,
  (editItem) => editItem.subtotals
);

export const getCharges = createSelector(
  editItemSelector,
  (editItem) => editItem.charges
);

export const getDecorations = createSelector(
  editItemSelector,
  (editItem) => editItem.decorations
);

export const getVariants = createSelector(
  editItemSelector,
  (editItem) => editItem.variants
);

export const getVariantSchema = createSelector(
  editItemSelector,
  (editItem) => editItem.variantSchema
);

export const getStageFormData = (stageId) =>
  createSelector(editItemSelector, (editItem) => editItem?.stageFormData?.[stageId] || {});

export const getSubtotalByView = (view) =>
  createSelector(editItemSelector, (editItem) => editItem.subtotals[view] || 0);

export const getChargesByView = (view) =>
  createSelector(editItemSelector, (editItem) => editItem.charges[view] || []);

export const getDecorationsByView = (view) =>
  createSelector(editItemSelector, (editItem) => editItem.decorations[view] || []);
